export default {
  "anchor": "AwFjg",
  "link": "TDaDO"
};